import React from "react";
import { Routes, Route, Navigate } from "react-router";
import ForgotPassword from "../Screens/Boarding/ForgotPassword";
import Login from "../Screens/Boarding/Login";
import ResetPassword from "../Screens/Boarding/ResetPassword";
import LoggedOutRoute from "./loggedOutRoutes";
import LoggedInRoute from "./loggedInRoutes";
import ChangePassword from "../Screens/Dashboard/ChangePassword";
import InvoiceRules from "../Screens/Dashboard/InvoiceRules";
import SystemUsageDetailPage from "../Screens/Dashboard/SystemUsageDetailPage";

const AppRoutes = (props) => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <LoggedOutRoute>
            <Login />
          </LoggedOutRoute>
        }
      />
      <Route
        exact
        path="/forgot_password"
        element={
          <LoggedOutRoute>
            <ForgotPassword />
          </LoggedOutRoute>
        }
      />
      <Route
        exact
        path="/reset_password"
        element={
          <LoggedOutRoute>
            <ResetPassword />
          </LoggedOutRoute>
        }
      />
      <Route
        exact
        path="/dashboard"
        element={
          <Navigate to="/systemUsageReports" replace />
        }
      />

      <Route
        exact
        path="/systemUsageReports"
        element={
          <LoggedInRoute>
            <InvoiceRules />
          </LoggedInRoute>
        }
      />
      <Route
        exact
        path="/systemUsageDetailPage/:systemId"
        element={
          <LoggedInRoute>
            <SystemUsageDetailPage />
          </LoggedInRoute>
        }
      />

      <Route
        exact
        path="/changePassword"
        element={
          <LoggedInRoute>
            <ChangePassword />
          </LoggedInRoute>
        }
      />
    </Routes>
  );
};
export default React.memo(AppRoutes);
